/*
 * @Description:
 * @Author: hanyu
 * @Date: 2020-03-10 14:40:23
 * @LastEditTime: 2020-11-12 15:53:25
 * @LastEditors: hanyu
 */
export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: '职考联盟',
  /**
   * 版本号
   */
  version: '5.18.0',

  /**
   * @description token在Cookie中存储的天数，默认30天
   */
  cookieExpires: 30,

  /**
   * @description localStorage存储用户信息的字段名
   */
  localUserKey: 'cloud-pc-userInfo'

};
